<template>
  <v-card flat class="pa-0 ma-0"
          :style="$vuetify.breakpoint.smAndDown ? 'background-color: transparent; overflow: unset' : 'overflow: unset'">
    <v-layout row wrap>
      <v-flex xs12>
        <v-autocomplete
            id="postalCode"
            clearable
            hide-selected
            v-model="postalcode"
            :items="postalCodes"
            :loading="isLoading"
            :search-input.sync="search"
            hide-no-data
            validate-on-blur
            :rules="[postalCodeRules]"
            :label="$lang.labels.postalCode"
            :placeholder="$lang.labels.startTyping"
            @blur="onBlurPostal()"
            @input="moveToLine1()"
            :hint="hint"
        ></v-autocomplete>
      </v-flex>

      <v-flex xs12 sm6 class="pr-1">
        <v-autocomplete
            id="line1"
            clearable
            hide-selected
            validate-on-blur
            :loading="isLoadingAddress"
            :search-input.sync="searchLine1"
            v-model="line1"
            :items="addressesLine1"
            hide-no-data
            :rules="[(v) => addressesLine1.includes(v) || showError('line1')]"
            :label="$lang.labels.line1AT"
            :placeholder="$lang.labels.startTyping"
            @input="moveToHouseNo()"
        ></v-autocomplete>
      </v-flex>

      <v-flex xs12 sm6 class="pl-1">
        <v-autocomplete
            id="line2"
            clearable
            hide-selected
            validate-on-blur
            v-model="line2"
            :search-input.sync="searchLine2"
            :items="addressesLine2"
            hide-no-data
            :rules="[(v) => addressesLine2.includes(v) || showError('line2')]"
            :label="$lang.labels.line2AT"
            :placeholder="$lang.labels.startTyping"
            @blur="onBlurLine2()"
        ></v-autocomplete>
      </v-flex>

      <v-flex xs12 sm6 class="pr-1">
        <v-text-field
            id="line3"
            v-model="line3"
            :label="$lang.labels.line3AT"
        ></v-text-field>
      </v-flex>

      <v-flex xs12 sm6 class="pl-1">
        <v-autocomplete
            id="townCity"
            clearable
            hide-selected
            validate-on-blur
            v-model="townCity"
            :search-input.sync="searchTownCity"
            :items="addressesTownCity"
            hide-no-data
            :rules="[(v) => addressesTownCity.includes(v) || showError('townCity')]"
            :label="$lang.labels.townCity"
            :placeholder="$lang.labels.startTyping"
        ></v-autocomplete>
      </v-flex>
      <p style="display: none !important;">{{ isValid }}</p>
    </v-layout>
  </v-card>
</template>

<script>
import { mapGetters } from 'vuex';

export default {
  name: 'AddressLookupAT',
  props: ['address', 'fromBack'],
  data: () => ({
    isLoadingAddress: false,
    isLoading: false,
    showNav: false,
    orderType: '',
    fullAddress: null,
    postalcode: '',
    line1: '',
    line2: '',
    line3: '',
    townCity: '',
    locality: '',
    comment: '',
    err: '',
    warn: '',
    success: '',
    successPostal: '',
    deliveryCharges: null,
    distanceInMiles: 0,
    total: 0,
    itemsTotal: 0,
    validPostal: null,
    selectAddress: null,
    selectAddressAT: null,
    calcTimeout: null,
    latitude: null,
    longitude: null,
    resourceId: null,
    postalCodes: [],
    search: null,
    searchLine1: null,
    searchLine2: null,
    searchTownCity: null,
    searchAddress: null,
    hint: '',
    showAddressFields: false,
    addressesResult: [],
    country: null,
    init: false,
  }),
  computed: {
    ...mapGetters({
      postalCode: 'postalCode',
      company: 'company',
      goDark: 'goDark',
    }),
    postalCodeRules() {
      if (this.country && this.postalcode) {
        return this.testPostalCodeRules(this.country, this.postalcode);
      }
      return this.$lang.errors.invalidZip;
    },
    addressesLine1() {
      return this.filterUniqueFields(this.addressesResult, 'line1');
    },
    addressesLine2() {
      return this.filterUniqueFields(this.addressesResult.filter(x => x.line1 === this.line1), 'line2');
    },
    addressesTownCity() {
      if (this.filterUniqueFields(this.addressesResult, 'townCity').length === 1) {
        // eslint-disable-next-line prefer-destructuring,vue/no-side-effects-in-computed-properties
        this.townCity = this.filterUniqueFields(this.addressesResult, 'townCity')[0];
      }
      return this.filterUniqueFields(this.addressesResult, 'townCity');
    },
    isValid() {
      const valid = this.addressesResult.find(x => x.postalCode === this.postalcode
          && x.line1 === this.line1
          && x.line2 === this.line2
          && x.townCity === this.townCity);
      // eslint-disable-next-line vue/no-side-effects-in-computed-properties
      if (valid) {
        this.fullAddress = { ...valid, line3: this.line3 || '' };
        this.$emit('submit', this.fullAddress);
      }
      if (!valid) {
        this.fullAddress = null;
      }
      return !!valid;
    },
  },
  watch: {
    search: {
      handler(val) {
        if (val) {
          this.search = this.search.trim();
        }
        if (this.init) {
          this.searchLine1 = '';
          this.addressesResult = [];
          this.getPostalCodes(val);
        }
      },
      deep: true,
    },
    searchLine1: {
      handler() {
        if (this.testPostalCodeRules(this.country, this.postalcode) === true
            && this.searchLine1 && this.searchLine1.length > 2 && this.init && !this.fromBack) {
          this.addressLookup(this.postalcode);
        }
        if (this.fromBack
            && this.searchLine1 && this.searchLine1.length > 2 && this.searchLine1 !== this.line1) {
          this.line1 = '';
          this.$emit('submit', 'Add address');
          this.addressLookup(this.postalcode);
        }
      },
      deep: true,
    },
    searchLine2: {
      handler() {
        if (this.fromBack && this.line2 && this.searchLine2 && this.searchLine2 !== this.line2) {
          this.line2 = '';
          this.$emit('submit', 'Add address');
          this.addressLookup(this.postalcode);
        }
      },
      deep: true,
    },
    postalcode() {
      this.postalcode = this.postalcode ? this.postalcode.trim() : '';
      if (this.testPostalCodeRules(this.country, this.postalcode) === true && this.init) {
        this.hint = this.$lang.success.postalSet;
        document.getElementById('postalCode')
          .blur();
        document.getElementById('line1')
          .click();
        document.getElementById('line1')
          .focus();
        this.line1 = null;
        this.searchLine1 = null;
        this.line2 = null;
        this.searchLine2 = null;
        this.townCity = null;
        this.line3 = null;
      }
    },
    line1() {
      if (!this.line1 && this.init) {
        this.line2 = null;
        this.searchLine2 = null;
        this.townCity = null;
        this.line3 = null;
      }
    },
    line2() {
      if (!this.line2 && this.init) {
        this.line3 = null;
      }
    },
    townCity() {
      if (this.townCity && this.searchTownCity && this.townCity === this.searchTownCity) {
        document.getElementById('townCity')
          .focus();
        document.getElementById('townCity')
          .blur();
      }
    },
  },
  methods: {
    showError(line) {
      this.startErrorAnimation(line);
      return 'Required!';
    },
    startErrorAnimation(elementId) {
      const el = document.getElementById(elementId);
      if (el) {
        el.classList.add('ahashakeheartache');
        setTimeout(() => {
          el.classList.remove('ahashakeheartache');
        }, 800);
      }
    },
    moveToHouseNo() {
      document.getElementById('line1')
        .blur();
      document.getElementById('line2')
        .click();
      document.getElementById('line2')
        .focus();
    },
    moveToLine1() {
      document.getElementById('postalCode')
        .blur();
      document.getElementById('line1')
        .click();
      document.getElementById('line1')
        .focus();
    },
    getPostalCodes(code) {
      if (!this.init) return;
      if (!code) return;
      code.trim()
        .toUpperCase();
      this.hint = '';
      if (this.country === 'AT' && code.length !== 4) return;
      this.isLoading = true;
      this.$webHelper.get(`address/postalcodes/${this.resourceId}`, {
        startswith: code.trim()
          .toUpperCase(),
      })
        .then((res) => {
          if (res.data && res.status === 200) {
            if (res.data.postalCodes.length === 0) {
              this.hint = this.$lang.errors.noPostalFound;
              this.isLoading = false;
            } else {
              if ((res.data.postalCodes.filter(x => x === this.postalcode)).length === 0) {
                this.postalCodes = res.data.postalCodes;
                this.line1 = '';
                this.searchLine1 = '';
              }
              if (res.data.postalCodes.length === 1) {
                this.postalcode = this.postalCodes[0];
                this.hint = this.$lang.success.postalSet;
              }
              this.isLoading = false;
            }
          }
        })
        .catch((err) => {
          this.err = err;
          this.isLoading = false;
        });
    },
    addressLookup(value) {
      if (!this.init) return;
      if (!value) return;
      if (this.country === 'AT' && value.length !== 4) return;
      if ((!value || !this.searchLine1 || (this.searchLine1 && this.searchLine1.length < 3)) && this.country === 'AT') return;
      this.isLoadingAddress = true;
      if (!this.fromBack) {
        this.addressesResult = [];
      }
      const payload = {
        postalCode: value.trim()
          .toUpperCase(),
        line1: this.searchLine1,
        country: this.country,
      };
      this.$webHelper.post(`address/${this.resourceId}`, payload)
        .then((res) => {
          if (res.data && res.status === 200 && res.data.addresses) {
            this.addressesResult = res.data.addresses || [];
            this.isLoadingAddress = false;
          } else {
            this.hint = res.data.statusText;
            this.isLoadingAddress = false;
          }
        })
        .catch((err) => {
          this.err = err;
          this.isLoadingAddress = false;
        });
    },
    testPostalCodeRules(countryToCheck, zip) {
      if (!zip) return this.$lang.errors.zipRequired;
      if (!countryToCheck) return this.$lang.errors.countryRequired;
      if (countryToCheck === 'AT') {
        return zip.length === 4;
      }
      return this.$lang.errors.countryUnsupported;
    },
    onBlurPostal() {
      if (this.postalCodes.includes(this.search)) {
        this.postalcode = this.search;
        if (this.init) this.addressLookup(this.postalcode);
      }
    },
    onBlurLine2() {
      if (this.searchLine2 && this.addressesLine2.includes(this.searchLine2.toUpperCase())) {
        this.line2 = this.searchLine2.toUpperCase();
      }
    },
    filterUniqueFields(addresses, property) {
      let filteredFieldList = addresses.map(address => address[property]);
      // eslint-disable-next-line max-len
      filteredFieldList = filteredFieldList.filter((item, index) => filteredFieldList.indexOf(item) === index)
        .filter(x => x !== undefined)
        .sort();
      return filteredFieldList;
    },
  },
  mounted() {
    this.country = this.company && this.company.address ? this.company.address.country : null;
  },
  created() {
    this.resourceId = localStorage.getItem('webShopResourceId');
    if (this.address) {
      this.fullAddress = { ...this.address };
      this.addressesResult = [this.address];
      this.postalCodes = [this.address.postalCode] || [];
      this.postalcode = this.address.postalCode;
      this.searchLine1 = this.address.line1;
      this.line1 = this.address.line1;
      this.searchLine2 = this.address.line2;
      this.line2 = this.address.line2;
      this.line3 = this.address.line3;
      this.townCity = this.address.townCity;
      setTimeout(() => {
        this.init = true;
      }, 100);
    } else {
      this.init = true;
    }
  },
};
</script>
<style lang="scss" scoped>
.ahashakeheartache {
  -webkit-animation: kf_shake 0.4s 1 linear;
  -moz-animation: kf_shake 0.4s 1 linear;
  -o-animation: kf_shake 0.4s 1 linear;
}
@-webkit-keyframes kf_shake {
  0% { -webkit-transform: translate(30px); }
  20% { -webkit-transform: translate(-30px); }
  40% { -webkit-transform: translate(15px); }
  60% { -webkit-transform: translate(-15px); }
  80% { -webkit-transform: translate(8px); }
  100% { -webkit-transform: translate(0px); }
}
@-moz-keyframes kf_shake {
  0% { -moz-transform: translate(30px); }
  20% { -moz-transform: translate(-30px); }
  40% { -moz-transform: translate(15px); }
  60% { -moz-transform: translate(-15px); }
  80% { -moz-transform: translate(8px); }
  100% { -moz-transform: translate(0px); }
}
@-o-keyframes kf_shake {
  0% { -o-transform: translate(30px); }
  20% { -o-transform: translate(-30px); }
  40% { -o-transform: translate(15px); }
  60% { -o-transform: translate(-15px); }
  80% { -o-transform: translate(8px); }
  100% { -o-origin-transform: translate(0px); }
}
</style>



// WEBPACK FOOTER //
// src/components/webshop/modals/AddressSearchAt.vue